export default __webpack_public_path__ + "static/media/chevron-up.inline.da483a8e.svg";